<template>
  <div class="prop-popup">
    <prop-item class="prop-popup-img" :detail="detail"></prop-item>
    <div class="prop-popup-text">
      <p class="prop-popup-text-name">{{ detail.NAME }}</p>
      <p class="prop-popup-text-num">{{ detail.AMOUNT || detail.COUNT }}</p>
    </div>
  </div>
</template>

<script>
import PropItem from '@components/officialStore/product/PropItem.vue'
export default {
  name: 'PropPopup',
  props: ['detail'],
  components: {
    PropItem
  }
}
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.prop-popup {
  display: flex;
  box-sizing: border-box;
  padding: 17px;
  background-size: cover;
  @psetbg ('prop-popup.png');
  &-img {
    margin-right: 17px;
  }
  &-text {
    font-size: 24px;
    color: var(--product-item-prop-popup-name);
    &-num {
      margin-top: 10px;
      color: var(--product-item-prop-popup-num);
    }
  }
}

</style>